// 封装复杂的mutations
import * as mutationTypes from './mutation-types'
import * as actionTypes from './action-types.js'
import {getAudioDetail,setAudioList} from '@/api/apis.js';


const actions = {
    example({commit,state}){
        commit(mutationTypes.SET_LOADING);
    },
    [actionTypes.GET_AUDIO_DETAIL]({commit,state},payload){
        return getAudioDetail({id:payload.id}).then(res=>{

            //第一次进入播放页更改路由的chapterId值视频列表的第一个视频的id
            if(payload.$route.params.chapterId==0){
                if(!res.data.chapterInfo.length){
                    return
                }

                payload.$router.replace({
                    name: 'playDetail',
                    params: {
                        bookId: res.data.id,
                        chapterId:res.data.chapterInfo[0].id
                    },
                    query:{
                        lang:payload.$route.query.lang || 'cn'
                    }
                })

            }
            if(payload.$route.fullPath.indexOf('hearing')<0 && payload.$route.fullPath.indexOf('play-audio')<0){
                //视频栏目设值
                commit({
                    type: mutationTypes.VIDEO_PLAY_DERAIL,
                    data: res.data
                })
                commit({
                    type: mutationTypes.VIDEO_PLAY_LIST,
                    list: res.data.chapterInfo
                })
            }else{
                //音频栏目设值
                commit({
                    type: mutationTypes.AUDIO_PLAY_DERAIL,
                    data: res.data
                })
                //是否在播放页面&& 是分享来的
                if(payload.$route.fullPath.indexOf('play-audio')>-1 && state.isShare){
                    let index = res.data.chapterInfo.findIndex((item) => {
                        return item.id === parseInt(payload.$route.params.chapterId)
                    })
                    commit({
                        type: mutationTypes.SET_CURRENT_INDEX,
                        index
                    })
                    commit({
                        type: mutationTypes.AUDIO_PLAY_LIST,
                        list: res.data.chapterInfo
                    })
                    commit({
                        type: mutationTypes.SET_SEQUENCE_LIST,
                        list: res.data.chapterInfo
                    })
                }
            }
        })
    }
}


export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js